import Section from "../../Section";
import {GenericTable} from "@dvrt/graphql-widgets";
import {HasPermission, Link} from "../../widgets";
import AssignExtension from "./AssignExtension";
import {useConcertoGenericQuery} from "../../../hooks";
import {ExtensionListFragment, ExtensionListFragmentDoc} from "@/queries.generated";
import {defineMessage, defineMessages} from "react-intl";

type Props = {
    locationId: number;
    domainId: number;
};

export default ({locationId, domainId}: Props) => {
    const query = useConcertoGenericQuery<ExtensionListFragment>("users", ExtensionListFragmentDoc, {
        extraVariables: {locationId},
    });

    return (
        <Section label={defineMessage({id: "related_extensions", defaultMessage: "Related users"})}>
            <GenericTable<ExtensionListFragment>
                query={query}
                labels={defineMessages({
                    displayName: {id: "displayName", defaultMessage: "Name"},
                    number: {id: "unused", defaultMessage: "Unused"},
                    "number.e164": {id: "e164", defaultMessage: "E.164"},
                    "number.shortNumber": {id: "shortNumber", defaultMessage: "Short number"},
                })}
                dataRenderers={{
                    displayName: (value, row) => {
                        return <Link to={`/domains/${domainId}/users/${row.id}/`}>{value}</Link>;
                    },
                }}
            />
            <HasPermission name="edit_location">
                <AssignExtension
                    locationId={locationId}
                    onSuccess={() => {
                        query.refetch();
                    }}
                />
            </HasPermission>
        </Section>
    );
};
